import './styles.scss';

export default function initMaps() {
  if (
    window.initialMapData !== undefined &&
    window.markers !== undefined &&
    window.google !== undefined
  ) {
    var initLocation = {
      lat: window.initialMapData.latData,
      lng: window.initialMapData.lngData,
    };
    var map = new window.google.maps.Map(document.getElementById('map'), {
      zoom: window.initialMapData.zoomData,
      center: initLocation,
    });
    var infowindow = new window.google.maps.InfoWindow({
      maxWidth: 300,
    });

    for (var i = 0; i < window.markers.length; i++) {
      let contentString =
        '<div id="content">' +
        '<div id="siteNotice">' +
        '</div>' +
        '<h1 id="firstHeading" class="firstHeading">' +
        window.markers[i].title +
        '</h1>' +
        '<div id="bodyContent">' +
        '<p>' +
        window.markers[i].description +
        '</p>' +
        '</div>';

      let marker = new window.google.maps.Marker({
        position: {
          lat: window.markers[i].lat,
          lng: window.markers[i].lng,
        },
        map: map,
        icon: window.initialMapData.customIcon,
        title: window.markers[i].title,
      });

      window.google.maps.event.addListener(
        marker,
        'click',
        (function (marker) {
          return function () {
            infowindow.setContent(contentString);
            infowindow.open(map, marker);
          };
        })(marker)
      );
    }
  }
}
